import React, { Component } from 'react';
import { Form, Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import ContentTile from 'components/atoms/layout/ContentTile';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import ButtonStandardSecondary from 'components/atoms/buttons/standard/Secondary';
import ButtonStandardPrimary from 'components/atoms/buttons/standard/Primary';
import QuillEditor from 'components/atoms/inputs/QuillEditor';
import 'react-day-picker/lib/style.css';

const EditNoteTile = styled(ContentTile) `
    border: 1px solid ${props => props.theme.colors.primary}; 
    background-color: #F5F9FD;
    padding: 0px 10px;
`;

const QuillWrapper = styled.div`
    background-color: #fff;
    margin-bottom: 10px;

    .ql-editor {
        min-height: 150px;
    }

    .ql-editor:focus {
        border: 1px solid ${props => props.theme.colors.tangerine}; 
    }

    .ql-toolbar {
        background-color: #f4f4f4
    }   
`;

const DatePickerWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;

    & .DayPicker-Day--selected {
        background-color: ${props => props.theme.colors.primary} !important;
        color: #fff;
    }

    & .DayPicker-Day {
        border-radius: 0 !important;
    }
    & .DayPicker-Day--start {
        border-top-left-radius: 50% !important;
        border-bottom-left-radius: 50% !important;
    }
    & .DayPicker-Day--end {
        border-top-right-radius: 50% !important;
        border-bottom-right-radius: 50% !important;
    }

    .DayPicker-Caption {
        text-align: center;
    }

    .DayPicker-NavButton--prev {
        margin-right: 14.5rem;

    }
    .DayPicker-NavButton {
        background-size: 70%;
        right: 0.5em;
    }

    .DayPickerInput-OverlayWrapper{
        position: absolute;
        top: 35px;
        left: -65px;

        ${breakpoint('xs', 'md')`
            top: 35px;
            left: 0px;
    `}
    }

    .DayPickerInput {
        font-size: 13px;
        margin-top: 10px;
    }

    .DayPickerInput input {
       padding: 4px;
       width: 100px;
    }

    .DayPickerInput input:focus {
        outline: 1px solid #FBAD19;
    }
    .DayPicker-Day--today {
        color: #FBAD19;
    }
    .dateInput {
        position: relative;
    }
    .dateInput label {
        position: absolute;
        top: -8px;
        left: 5px;
        padding: 0px 2px;
        font-size: 10px;
        color: #656158;
        background-color: #fff;
    }

    .fromToDivider {
        margin: 7px 10px 0px;
    }
`;

class EditNoteForm extends Component {
    createDatePickerProps(fieldName) {
        const resultProps = {
            name: `meta.${fieldName}`,
            component: ({ input }) => <DayPickerInput
                value={input.value}
                onDayChange={(value) => {
                    input.onChange(value);
                }}
                keepFocus={false}
                placeholder='MM-DD-YYYY'
                format='MM-DD-YYYY'
                formatDate={(date, format) => (date ? moment(date).format(format) : '')}
                parseDate={(str, format) => {
                    if (str) {
                        const theDate = moment(str, format, true);

                        if (theDate.isValid()) {
                            return theDate.toDate();
                        }
                    }

                    return '';
                }}
                dayPickerProps={{ numberOfMonths: 1 }} />,
        };

        return resultProps;
    }

    render() {
        return (
            <Form onSubmit={this.props.handleSubmit()} id="createNoteForm">
                <EditNoteTile>
                    <Row>
                        <Col xs={12} >
                            <DatePickerWrapper>
                                <span className="InputFromTo-from dateInput">
                                    <Field {...this.createDatePickerProps('start')} /></span>{' '}
                                <span className='fromToDivider'> — </span>{' '}
                                <span className='InputFromTo-to dateInput'>
                                    <Field {...this.createDatePickerProps('end')} />
                                </span>
                            </DatePickerWrapper>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} md={10}>
                            <QuillWrapper>
                                <Field component={QuillEditor}
                                    name='meta.content'/>
                            </QuillWrapper>

                        </Col>

                        <Col sm={12} md={2}>
                            <ButtonStandardPrimary style={{ marginBottom: '10px' }} width="100%" type="submit">Save</ButtonStandardPrimary>
                            <ButtonStandardSecondary style={{ marginBottom: '10px' }} width="100%" type="cancel" onClick={() => this.props.handleToggle(false)}>Cancel</ButtonStandardSecondary>
                        </Col>

                    </Row>
                </EditNoteTile>
            </Form>
        );
    }
}

EditNoteForm.propTypes = {
    handleSubmit: PropTypes.func,
    entityId: PropTypes.number,
    formHeader: PropTypes.string
};
export default EditNoteForm;



// WEBPACK FOOTER //
// ./src/components/organisms/forms/EditNote.js